var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({ref:"root"},'div',_vm.$attrs,false),[_vm._t("default",function(){return [_c('SloLoader',{attrs:{"loading":true,"size":"xl"}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }